<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
		<vx-tooltip text="Edit" position="bottom" class="mr-4 inline-block">
			<feather-icon icon="Edit3Icon"
				:svgClasses="`h-5 w-5 ${!permissionCheck($route.name, 'edit') || params.data.deleted_at != null ? 'cursor-not-allowed opacity-50' : 'hover:text-primary cursor-pointer'}`"
				@click="updatePrompt()"/>
		</vx-tooltip>
			
		<vx-tooltip v-if="params.data.deleted_at == null" text="Deactivate" position="bottom" class="inline-block">
			<feather-icon icon="Trash2Icon"
				:svgClasses="`h-5 w-5 ${!permissionCheck($route.name, 'delete') ? 'cursor-not-allowed opacity-50' : 'hover:text-danger cursor-pointer'}`"
				@click="confirmDelete()"/>
		</vx-tooltip>
		<vx-tooltip v-else text="Activate" position="bottom" class="inline-block">
			<feather-icon icon="RotateCcwIcon"
				:svgClasses="`h-5 w-5 ${!permissionCheck($route.name, 'delete') ? 'cursor-not-allowed opacity-50' : 'hover:text-success cursor-pointer'}`"
				@click="confirmDelete()"/>
		</vx-tooltip>

		<vs-prompt id="edit-prompt" :title='`Update Suffix: "${params.data.suffix}"`' @cancel="prePopulateEdit" @close="prePopulateEdit" @accept="updateRecord" :active.sync="editSuffix['prompt']">
			<div class="vx-row">
				<div class="vx-col w-1/2 flex justify-between">
					<label for="basic">Basic Suffix:</label>
					<vs-switch id="basic" color="success" v-model="editSuffix['basic']" />
				</div>
				<div class="vx-col w-1/2 flex justify-between">
					<label for="space">Space Required:</label>
					<vs-switch id="space" color="success" v-model="editSuffix['space']" />
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
	export default {
		name: 'CellRendererActions',
		data() {
			return {
				editSuffix: {
					name: '',
					basic: true,
					space: false,
					prompt: false
				}
			}
		},
		methods: {
			prePopulateEdit() {
				// Prefill row's data
				this.editSuffix['name'] = this.params.data.suffix;
				this.editSuffix['basic'] = !!this.params.data.basic;
				this.editSuffix['space'] = !!this.params.data.space_required;
			},
            confirmDelete() {
				if(this.permissionCheck(this.$route.name, 'delete')) {
					if (this.params.data.deleted_at == null) {
						this.$vs.dialog({
							type: 'confirm',
							color: 'danger',
							title: 'Confirm Status Change',
							text: `Do you want to deactivate "${this.params.data.suffix}"?`,
							accept: this.deleteRecord,
							parameters: 'deactivate',
							acceptText: 'Deactivate'
						})
					}
					else {
						this.$vs.dialog({
							type: 'confirm',
							color: 'success',
							title: 'Confirm Status Change',
							text: `Do you want to activate "${this.params.data.suffix}"?`,
							accept: this.deleteRecord,
							parameters: 'activate',
							acceptText: 'Activate'
						})
					}
				}
			},
            showDeleteSuccess(flag) {
				if (flag == 'activate') {
					this.$vs.notify({
						color: 'success',
						title: 'Suffix Activated',
						text: 'The selected suffix was successfully activated'
					})
				}
				else {
					this.$vs.notify({
						color: 'success',
						title: 'Suffix Deactivated',
						text: 'The selected suffix was successfully deactivated'
					})
				}
            },
            deleteRecord(flag) {
                this.$axiosSecure.delete(`/suffixes/${this.params.data.id}`, {
						params: {
							'action': flag
						}
					})
                    .then(() => {
                        this.$root.$emit('refreshPage');

                        this.showDeleteSuccess(flag);
                    })
                    .catch(error => {
                        // Error notification
                        if (error.response.status == 401) {
                            this.$vs.notify({
                                color: 'danger',
                                title: `Not authorized`,
                                text: `You do not have permission to access the resource`
                            });
                        } else if (error.response.status == 403) {
                            // Token invalid so logout
                            this.$root.$emit('appLogout');
                        } else {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Something went wrong',
                                text: 'Please contact the server admin'
                            });
                        }
                        // eslint-disable-next-line no-console
                        console.log(error);
                    })

			},
            updatePrompt(flag) {
                if(this.permissionCheck(this.$route.name, 'edit') && this.params.data.deleted_at == null) {
                    this.editSuffix['prompt'] = true;
                }
            },
            updateRecord() {
				this.$axiosSecure.patch(`/suffixes/${this.params.data.id}`, {
						'name': this.editSuffix.name,
						'basic': Number(this.editSuffix.basic),
						'space': Number(this.editSuffix.space),
					})
					.then(() => {
						this.$root.$emit('refreshPage');

						this.showUpdateRecordSuccess();
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					})
            },
			showUpdateRecordSuccess() {
				this.$vs.notify({
					color: 'success',
					title: 'Suffix Updated',
					text: 'The suffix was successfully updated'
				})
			},
		},
		beforeMount() {
			// Prefill row's data
			this.prePopulateEdit();
		}
	}
</script>
